/**
 * Panel de pistas (MVP §6.3): lista numerada; al pulsar una se tacha y se resaltan las
 * celdas que menciona.
 *
 * El tachado es estado del jugador, no del motor: no dice que la pista esté «usada»
 * ni la valida, solo la aparta de la vista. Volver a pulsarla la restaura y quita el
 * resaltado.
 */

import type { RenderedClue } from '@murdoku/content';

export interface CluesPanelProps {
  clues: readonly RenderedClue[];
  struck: readonly string[];
  /** Pista cuyo resaltado está activo en la rejilla. */
  highlightedId: string | null;
  onToggle: (id: string) => void;
}

export function CluesPanel({
  clues,
  struck,
  highlightedId,
  onToggle,
}: CluesPanelProps) {
  return (
    <section aria-labelledby="pistas-titulo" className="flex flex-col gap-3">
      <h2 id="pistas-titulo" className="font-display text-2xl">
        Pistas
      </h2>
      <ol className="flex flex-col gap-1">
        {clues.map((clue, index) => {
          const isStruck = struck.includes(clue.id);
          const isHighlighted = highlightedId === clue.id;
          return (
            <li key={clue.id}>
              <button
                type="button"
                onClick={() => onToggle(clue.id)}
                aria-pressed={isStruck}
                className={`focus-ring flex w-full items-start gap-3 rounded-md px-2 py-2 text-left text-sm ${
                  isHighlighted ? 'bg-surface-raised' : ''
                } ${isStruck ? 'text-text-muted line-through' : 'text-text'}`}
              >
                <span className="text-text-muted font-mono text-xs leading-6">
                  {index + 1}.
                </span>
                <span className="leading-6">{clue.text}</span>
              </button>
            </li>
          );
        })}
      </ol>
      <p className="text-text-muted text-xs">
        Pulsa una pista para tacharla y ver en la rejilla de quién habla.
      </p>
    </section>
  );
}
